"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefundPagePlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var NoteRequest_1 = require("../../model/NoteRequest");
var commonFunctions_1 = require("../../helpers/commonFunctions");
var RefundPagePlain = /** @class */ (function (_super) {
    __extends(RefundPagePlain, _super);
    function RefundPagePlain(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.getInputClassName = function (field) {
            if (field === "amount") {
                return _this.state.amountInputValid || !_this.state.maxAmountInputReached ? "form-control col-2" : "form-control col-2 is-invalid";
            }
            if (field === "description") {
                return _this.state.descriptionInputValid ? "form-control" : "form-control is-invalid";
            }
            return "";
        };
        _this.formValidation = function () {
            _this.setState({ formValid: !!_this.state.amount && !!_this.state.description && !_this.state.maxAmountInputReached });
        };
        _this.handleOnAmountChange = function (event) {
            _this.setState({ amount: event.target.value });
            _this.setState({
                amountInputValid: !!event.target.value,
                maxAmountInputReached: (_this.state.maxAmount < event.target.value)
            });
            _this.formValidation();
        };
        _this.handleOnDescriptionChange = function (event) {
            _this.setState({
                description: event.target.value,
                descriptionInputValid: !!event.target.value
            });
            _this.formValidation();
        };
        _this.validate = function () {
            _this.setState({
                amountInputValid: !!_this.state.amount,
                maxAmountInputReached: (_this.state.maxAmount < _this.state.amount),
                descriptionInputValid: !!_this.state.description
            });
            _this.formValidation();
        };
        _this.handleOnSubmit = function (event) {
            var _a;
            event.preventDefault();
            _this.supportPortalService.logAgentActivity(_this.props.params.id, { "action": "Refund payment: ".concat(_this.state.amount), "customer": _this.props.params.number, "id": (_a = _this.state.agentActivityId) === null || _a === void 0 ? void 0 : _a.toString() }).subscribe();
            _this.supportPortalService.getCardMaxRefundAmount(_this.props.params.number).subscribe(function (value) {
                _this.setState({ maxAmount: value });
                _this.setState({ loadingRefund: false });
                _this.validate();
                if (_this.state.formValid && _this.state.amountInputValid && _this.state.descriptionInputValid) {
                    _this.setState({ loadingRefund: true });
                    var refund_1 = { amount: _this.state.amount, description: _this.state.description };
                    if (_this.state.maxAmount >= _this.state.amount) {
                        _this.supportPortalService.doRefund(_this.props.params.number, refund_1).subscribe(function (e) { return __awaiter(_this, void 0, void 0, function () {
                            var noteRequest;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(e instanceof Error)) return [3 /*break*/, 1];
                                        this.setState({ loadingRefund: false });
                                        return [3 /*break*/, 3];
                                    case 1:
                                        noteRequest = new NoteRequest_1.default();
                                        noteRequest.text = "Issued refund:\n" +
                                            "\u25CF Amount: \u00A3" + refund_1.amount + "\n" +
                                            "\u25CF Description: " + refund_1.description;
                                        return [4 /*yield*/, this.supportPortalService.createNote(this.props.params.id, noteRequest).toPromise()];
                                    case 2:
                                        _a.sent();
                                        this.props.navigate("/customers/".concat(this.props.params.id, "/payments?policy=").concat(this.props.params.number));
                                        window.location.reload();
                                        _a.label = 3;
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); });
                    }
                }
            });
        };
        _this.state = {
            amount: 0,
            maxAmount: 0,
            description: "",
            amountInputValid: true,
            descriptionInputValid: true,
            formValid: false,
            loadingRefund: true,
            maxAmountInputReached: false
        };
        return _this;
    }
    RefundPagePlain.prototype.render = function () {
        if (this.state.loadingRefund) {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
        else if (this.supportPortalTemplates.userHasRole(["Administrator", "CSR_Lead", "CSR"])) {
            return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.Overlay, { show: this.state.loadingRefund }), this.supportPortalTemplates.renderBackLink("Customer details", true, "/customers/".concat(this.props.params.id)), (0, jsx_runtime_1.jsxs)("form", { className: "row panel-border px-3", onSubmit: this.handleOnSubmit, children: [(0, jsx_runtime_1.jsxs)("div", { className: "form-group col-12", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "amount", children: "Select refund amount:" }), (0, jsx_runtime_1.jsx)("input", { type: "number", name: "amount", step: "0.01", className: this.getInputClassName("amount"), onChange: this.handleOnAmountChange, min: "0", pattern: "\\d+(\\.\\d{1,2})?" }), this.state.amountInputValid ? "" :
                                        (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: "This is a mandatory field!" }), !this.state.maxAmountInputReached ? "" :
                                        (0, jsx_runtime_1.jsxs)("div", { className: "invalid-feedback d-block", children: ["Maximum refund amount (", (0, commonFunctions_1.getAmountToDisplay)(this.state.maxAmount), ") is reached! "] }), (0, jsx_runtime_1.jsx)("label", { htmlFor: "description", className: "mt-3", children: "Type refund description:" }), (0, jsx_runtime_1.jsx)("input", { type: "text", name: "description", className: this.getInputClassName("description"), onChange: this.handleOnDescriptionChange }), this.state.descriptionInputValid ? "" :
                                        (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: "This is a mandatory field!" })] }), (0, jsx_runtime_1.jsx)("div", { className: "form-group col-12 clearfix", children: (0, jsx_runtime_1.jsx)("button", { type: "submit", className: "btn btn-primary mr-0 float-right", children: "Submit" }) })] })] }));
        }
        else {
            return this.supportPortalTemplates.renderErrorPage();
        }
    };
    RefundPagePlain.prototype.componentDidMount = function () {
        var _this = this;
        this.supportPortalService.getCardMaxRefundAmount(this.props.params.number).subscribe(function (value) {
            _this.setState({ maxAmount: value });
            _this.setState({ loadingRefund: false });
        });
        this.supportPortalService.logAgentActivity(this.props.params.id, { "action": "No Action", "customer": this.props.params.number }).subscribe(function (agentActivity) {
            _this.setState({ agentActivityId: agentActivity.id });
        });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], RefundPagePlain.prototype, "supportPortalService", void 0);
    RefundPagePlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], RefundPagePlain);
    return RefundPagePlain;
}(React.Component));
exports.RefundPagePlain = RefundPagePlain;
exports.default = (0, components_1.withRouter)(RefundPagePlain);
//# sourceMappingURL=RefundPage.js.map